import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../components/Layout.vue'
import Index from '../components/Index'
import Produce from '../components/Produce'
import Partner from '../components/Partner'
import About from '../components/About'
import News from '../components/News'
import Service from '../components/Service'
import Credit from '../components/Credit'
import helpCenter from '../components/helpCenter'
import Article from '../components/Article'
import mIndex from '../components/mobile/index'
import mBrief from '../components/mobile/brief'
import mPartner from '../components/mobile/partner.vue'
import mService from '../components/mobile/service.vue'
import LayOutM from '../components/mobile/layoutM.vue'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/pc',
            name: 'Layout',
            component: Layout,
            children: [
                {
                    path: '',
                    name: 'Index',
                    component: Index
                },
                {
                    path: 'produce',
                    name: 'Produce',
                    component: Produce
                },
                {
                    path: 'partner',
                    name: 'Partner',
                    component: Partner
                },
                {
                    path: 'about',
                    name: 'About',
                    component: About
                },
                {
                    path: 'news',
                    name: 'News',
                    component: News
                },
                {
                    path: 'service',
                    name: 'Service',
                    component: Service
                },
                {
                    path: 'credit',
                    name: 'Credit',
                    component: Credit
                },
                {
                    path: 'helpCenter',
                    name: 'helpCenter',
                    component: helpCenter
                },
                {
                    path: 'article',
                    name: 'Article',
                    component: Article
                },
            ]
        },
        {
            path:'/mobile',
            name:'mobile',
            component:LayOutM,
            children:[
                {
                    path: '',
                    name: 'mIndex',
                    component: mIndex
                },
                {
                    path: 'mBrief',
                    name: 'mBrief',
                    component: mBrief
                },
                {
                    path: 'mPartner',
                    name: 'mPartner',
                    component: mPartner
                },
                {
                    path: 'mService',
                    name: 'mService',
                    component: mService
                }
            ]
        },
        {
            path: '/news',
            name: 'NewsLayout',
            component: () => import('../views/components/LayoutNews.vue'),
            children: [
                {
                    path: 'view/:id',
                    name: 'NewsLayoutView',
                    component: () => import('../views/news-view/index.vue')
                },
            ]
        },

            
    ]
})
export default router